import React, { Component } from "react";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

// core components
import GridItem from "../../../views/GridItem";
import GridContainer from "../../../views/GridContainer";
import Table from "../../../views/Table";
import Card from "../../../views/Card";
import CardHeader from "../../../views/CardHeader";
import CardBody from "../../../views/CardBody";
import Button from '@material-ui/core/Button';
import IconButton from "@material-ui/core/IconButton";
import CloudDownloadOutlined from '@material-ui/icons/CloudDownloadOutlined';
import Typography from '@material-ui/core/Typography';
import { Grid } from "@material-ui/core";
import OutlinedInput from '@material-ui/core/OutlinedInput';
import { withSnackbar } from 'notistack';
import moment from 'moment-timezone'
import ImageView from './ImageView'
import Edit from './Edit'
import { styles } from './styles';
import ic_pdf from '../../../../assets/ic_pdf.svg';
import RemoveButton from './ConfirmDialog'
import Apis from '../../../../utils/Apis'
import Workbook from 'react-excel-workbook'
import { ExcelExport, ExcelExportColumn } from '@progress/kendo-react-excel-export';

function convert2Date(str) {
    /* input format: 2019-05-31 03:51 AM */
    var d = str.match(/[0-9]+/g);
    return new Date(Number(d[0]), Number(d[1]) - 1, Number(d[2]), Number(d[3]), Number(d[4]), (isNaN(d[5]) ? 0 : Number(d[5])), (isNaN(d[6]) ? 0 : Number(d[6])));
}

function convert2mins(str) {
    /* input format: 17h 34m */
    var d = str.match(/[0-9]+/g);
    return Number(d[0]) * 60 + Number(d[1]);
}

function getNZDate(date_time) {
    let date = moment(date_time).local().format("YYYY-MM-DD hh:mm:ss.SSS A");
    return date;
}

function padDigits(number, digits) {
    return Array(Math.max(digits - String(number).length + 1, 0)).join(0) + number;
}

class WorkingHistory extends Component {

    state = {
        totalCount: 0,
        pageNumber: 1,
        history: [],
        export_history: [],
        temp_page: [],
        history_count: 0,
        isLoading: false,
        open_image: false,
        open_edit: false,

        id: '',
        name: '',
        working_hour: 0,
        pay_hour: 0,
        worker_id: '',
        site_id: '',
        site_name: '',
        type_id: '',
        type_name: '',

        sites: [],
        types: [],

        name: '',
        typing: false,
        typingTimeout: 0,
        search_str: '',
    }

    _exporterLastWeek;
    exportLastWeek = () => {
        this.save(this._exporterLastWeek);
    }
    
    save = (component) => {
        this.handleGetLastWeekData(component);
    };

    GetLastWeekDate = () => {
        var now = new Date();
        var nowDayOfWeek = now.getDay();
        var nowYear = now.getYear();
        var nowMonth = now.getMonth();
        var nowDay = now.getDate();

        nowYear += (nowYear < 2000) ? 1900 : 0;
        nowDayOfWeek = nowDayOfWeek == 0 ? 7 : nowDayOfWeek;

        return {
            lastWeekStartDate: new Date(nowYear, nowMonth, (nowDay - nowDayOfWeek + 1 - 7), 0x00, 0x00, 0x00, 0x000),
            lastWeekEndDate: new Date(nowYear, nowMonth, (nowDay + 6 - nowDayOfWeek + 1 - 7), 23, 59, 59, 999)
        };
    }

    isSameDate = (date1, date2) => {
        if (date1.getYear() === date2.getYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate()) {
            return true;
        }

        return false;
    }

    genNewOutItem = (beginItem, beginMins) => {
        var weekdays_str = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        var newDate = convert2Date(getNZDate(beginItem['start_time']));
        var newDateStr = padDigits(newDate.getFullYear(), 4) + '-' + padDigits(newDate.getMonth() + 1, 2) + '-' + padDigits(newDate.getDate(), 2) + ' (' + weekdays_str[newDate.getDay()] + ')';

        return { 'Week': beginItem['week'], 'Name': beginItem['worker_name'], 'No': beginItem['worker_no'], 'Date': newDateStr, 'Working Hours(m)': this.convertMinsToHrsMins(beginMins), 'Working Hours(h)': this.convertMinsToHrs(beginMins), 'Type': beginItem['type_name'], 'Site': beginItem['site_name'], 'Location': beginItem['location'], 'Ref': beginItem['ref'] };
    }

    genStatOutItem = (beginItem, beginMins) => {
        return { 'Week': 'Summary: ', 'Name': beginItem['worker_name'], 'No': beginItem['worker_no'], 'Date': '', 'Working Hours(m)': this.convertMinsToHrsMins(beginMins) + ' (Total)', 'Working Hours(h)': this.convertMinsToHrs(beginMins) + ' (Total)', 'Type': '', 'Site': '', 'Location': '', 'Ref': '' };
    }

    genNewDetailOutItem = (beginItem, beginMins) => {
        return { 'Week': beginItem['week'], 'Name': beginItem['worker_name'], 'No': beginItem['worker_no'], 'Start': getNZDate(beginItem['start_time']), 'Finish': getNZDate(beginItem['finish_time']), 'Date': getNZDate(beginItem['date']), 'Working Hours(m)': this.convertMinsToHrsMins(beginMins), 'Working Hours(h)': this.convertMinsToHrs(beginMins), 'Type': beginItem['type_name'], 'Site': beginItem['site_name'], 'Location': beginItem['location'], 'Ref': beginItem['ref'] };
    }

    mergeSortedData = (sortedData) => {
        var mergeBeginItem;
        var mergeMins = 0;
        var statBeginItem;
        var statHours = 0;
        var mergedDataOut = [];
        for (var i = 0; i < sortedData.length; i++) {
            var curItem = sortedData[i];
            if (0 == i) {
                mergeBeginItem = statBeginItem = curItem;
                mergeMins = statHours = curItem['working_hours'];
                continue;
            }

            /* merge each worker's same day week hours */
            if (curItem['worker_no'] === mergeBeginItem['worker_no']
            && true === this.isSameDate(convert2Date(mergeBeginItem['start_time']), convert2Date(curItem['start_time']))) {
                mergeMins = mergeMins + curItem['working_hours'];
            }
            else {
                var outItem = this.genNewOutItem(mergeBeginItem, mergeMins);
                mergedDataOut = [
                  ...mergedDataOut,
                  outItem
                ];
                mergeBeginItem = curItem;
                mergeMins = curItem['working_hours'];
            }

            /* statistic each worker's week hours */
            if (curItem['worker_no'] !== statBeginItem['worker_no']) {
                var outItem = this.genStatOutItem(statBeginItem, statHours);
                mergedDataOut = [
                  ...mergedDataOut,
                  outItem
                ];
                statBeginItem = curItem;
                statHours = curItem['working_hours'];
            }
            else {
                statHours = statHours + curItem['working_hours'];
            }
        }

        /* output last item and static item */
        if (sortedData.length === i && 0 !== sortedData.length) {
            var outItem;
            outItem = this.genNewOutItem(mergeBeginItem, mergeMins);
            mergedDataOut = [
              ...mergedDataOut,
              outItem
            ];

            outItem = this.genStatOutItem(statBeginItem, statHours);
            mergedDataOut = [
              ...mergedDataOut,
              outItem
            ];
        }

        return mergedDataOut;
    }

    GenerateDetailedSheetData = (header, data, sheet_name) => {
        var sheet;
        var columns = [];
        var filter = null;
        var freezePane = { 'colSplit': 0, 'rowSplit': 1 };
        var rows = [];
        var cells = [];

        /* columns */
        for (var i = 0; i < header.length; i++) {
            columns = [...columns, { 'width': 3, 'autoWidth': true }];
        }

        /* rows header */
        for (var i = 0; i < header.length; i++) {
            cells = [...cells, { 'background': '#FFFF00', 'color': '#000000', 'value': header[i], 'colSpan': 1, 'rowSpan': 1, 'textAlign': 'left','borderLeft': {'color': '#000000'}, 'borderRight': {'color': '#000000'}, 'borderTop': {'color': '#000000'}, 'borderBottom': {'color': '#000000'}, 'bold': true}];
        }
        rows = [...rows, { 'type': 'header', 'cells': cells }];

        /* rows data */
        for (var i = 0; i < data.length; i++) {
            var bgcolor = '#FFFFFF'; // white
            var font_color = '#000000'; // black
            cells = []
            if (data[i]['Week'] === 'Summary: ') {
                bgcolor = '#000000';
                font_color = '#FFFFFF';
            }
            for (var j = 0; j < header.length; j++) {
                cells = [...cells, { 'background': bgcolor, 'color': font_color, 'value': data[i][header[j]], 'textAlign': 'left', 'borderLeft': {'color': '#000000'}, 'borderRight': {'color': '#000000'}, 'borderTop': {'color': '#000000'}, 'borderBottom': {'color': '#000000'}}];
            }
            rows = [...rows, { 'type': 'data', 'level': null, 'cells': cells}];
        }

        sheet = { 'name': sheet_name, 'columns': columns, 'filter': filter, 'freezePane': freezePane, 'rows': rows };

        return sheet;
    }

    getLastWeekData = (tbl_data, weekstart, weekend) => {
        var newdata = [];

        /* find data */
        for (var i = 0; i < tbl_data.length; i++){
            var row = tbl_data[i];
            var startworktime = convert2Date(getNZDate(row['start_time']));

            if (weekstart <= startworktime && startworktime <= weekend) {
                newdata = [
                  ...newdata,
                  row,
                ];
            }
        }
        

        /* sort data */
        var sortedData = newdata.sort(
          (a, b) => {
            var NoA = Number(a['worker_no']);
            var NoB = Number(b['worker_no']);
            var DateA = convert2Date(a['start_time']);
            var DateB = convert2Date(b['start_time']);

            if (NoA < NoB) {
              return -1;
            }
            else if (NoA > NoB) {
              return 1;
            }
            else {
              if (DateA < DateB) {
                return -1;
              }
              else if (DateA > DateB) {
                return 1;
              }
              else {
                return 0;
              }
            }
          }
        );

        /* merge data of the same worker_no in the same day:  excel format */
        var mergedDataOut = this.mergeSortedData(sortedData);

        /* generate sheet1 format data */
        var merged_header = ['Week', 'Name', 'No', 'Date', 'Working Hours(m)', 'Working Hours(h)', 'Type', 'Site', 'Location', 'Ref'];
        var sheetData1 = this.GenerateDetailedSheetData(merged_header, mergedDataOut, 'Summary');


        /* sorted data:  excel format */
        var sortedDataOut = [];
        for (var i = 0; i < sortedData.length; i++) {

            var curItem = sortedData[i];
            var outItem = this.genNewDetailOutItem(curItem, curItem['working_hours']);
            sortedDataOut = [
              ...sortedDataOut,
              outItem
            ];
        }

        /* generate sheet2 format data */
        var sorted_header = ['Week', 'Name', 'No', 'Start', 'Finish', 'Date', 'Working Hours(m)', 'Working Hours(h)', 'Type', 'Site', 'Location', 'Ref'];
        var sheetData2 = this.GenerateDetailedSheetData(sorted_header, sortedDataOut, 'Detail');

        return {
            worksheet1: sheetData1,
            worksheet2: sheetData2
        };
    }

    getPureHistory = async(component, callback) => {
        let res = await Apis.getHistory('');
        let response = res.data;
        let history = response.history;
        
        callback(component, history);
    }

    lastWeekCallback = (component, tbl_data) => {
        var weekdate = this.GetLastWeekDate();

        var lastweek_history = this.getLastWeekData(tbl_data, weekdate.lastWeekStartDate, weekdate.lastWeekEndDate);

        const options = component.workbookOptions();

        options.sheets[0] = lastweek_history.worksheet1;
        options.sheets = [...options.sheets, lastweek_history.worksheet2];

        component.save(options);
    }

    handleGetLastWeekData = (component) => {
        this.getPureHistory(component, this.lastWeekCallback);
    }

    componentWillMount() {
        const { pageNumber } = this.state;
        this.getHistory(pageNumber, '');
    }


    getDate = (date_time) => {
        let date = moment(date_time).local().format("YYYY-MM-DD hh:mm A");
        return date;//date_time.substring(0, 10);
    }

    getTime(date_time) {
        // http://momentjs.com/docs/#/manipulating/local/
        let time = moment(date_time).local().format("hh:mm A");
        return time;//date_time.substring(11, 16);
    }
    convertMinsToHrsMins = (minutes) => {
        var h = Math.floor(minutes / 60);
        var m = minutes % 60;
        h = h < 10 ? '0' + h : h;
        m = m < 10 ? '0' + m : m;
        return h + 'h ' + m + 'min';
    }
    convertMinsToHrs = (minutes) => {
        var h = Math.round((Math.floor(minutes) / 60) * 100) / 100;
        return h.toFixed(2) + 'h';
    }
    getHistory = async (pageNumber, key) => {
        this.setState({ isLoading: true });
        try {
            this.setState({ isLoading_country_ip: true });
            let res = await Apis.getHistory(key);
            let response = res.data;
            let history = response.history;


            let site = response.site;
            let type = response.type;
            this.setState({
                sites: site,
                types: type
            })
            const { classes } = this.props;
            let temp = [];
            let temp_history = [];
            var index = 0;
            for (let i = 0; i < history.length; i++) {
                let id = history[i]['_id'];
                let ref = history[i]['ref'];
                let date = this.getDate(history[i]['date']);

                let week = moment(history[i]['finish_time']).week();
                let dayofweek = moment(history[i]['finish_time']).day();
                week = (0 == dayofweek ? week -1: week);

                let no = history[i]['worker_no'];
                let worker_id = history[i]['worker_id'];
                let name = history[i]['worker_name'];
                let type_id = history[i]['type_id'];
                let type_name = history[i]['type_name'];
                let site_name = history[i]['site_name'];
                let site_id = history[i]['site_id'];
                let start_time = this.getDate(history[i]['start_time']);
                let finish_time = this.getDate(history[i]['finish_time']);
                let working_hours = this.convertMinsToHrsMins(Math.floor(history[i]['working_hours']));
                let working_hours_h = this.convertMinsToHrs(Math.floor(history[i]['working_hours']));
                let location = history[i]['location'];
                let captured_image = history[i]['captured_image'];
                let image_url = history[i]['image_url'];

                /* ϵͳ��ʱ����ʵ�ʴ�ʱ�䲻��ʱ����ɫ������ʾ */
                let highlight_row = (finish_time !== date ? true: false);

                /* �޸Ĺ��ļ�¼����ʱ����ʲ�һ��ʱ����ɫ������ʾ */
                let seconds = (moment(history[i]['finish_time']) - moment(history[i]['start_time'])) / 1000;
                let intvalue_sec = Math.floor(seconds);
                let total_m = Math.floor(intvalue_sec / 60);
                if (total_m > 4*60) /* lunch break */
                {
                    total_m = total_m - 60;
                }
                let calc_working_hours_h = this.convertMinsToHrs(Math.floor(total_m));
                let highlight_font = (working_hours_h !== calc_working_hours_h ? true: false);
                /* if(highlight_font)
                {
                        console.log("record:"+working_hours_h+", real:"+calc_working_hours_h);
                        console.log(history[i]);
                }*/

                temp = [...temp,
                [
                    <Typography noWrap className={classes.typographyContent}>{week}</Typography>,
                    <Typography noWrap className={classes.typographyContent}>{name}</Typography>,
                    <Typography noWrap className={classes.typographyContent}>{no}</Typography>,
                    <Typography noWrap className={classes.typographyContent}>{start_time}</Typography>,
                    <Typography noWrap className={classes.typographyContent}>{finish_time}</Typography>,
                    <Typography noWrap className={classes.typographyContent}>{date}</Typography>,
                    (highlight_font ? <Typography noWrap className={classes.typographyHighlightContent}>{working_hours}</Typography> : <Typography noWrap className={classes.typographyContent}>{working_hours}</Typography>),
                    (highlight_font ? <Typography noWrap className={classes.typographyHighlightContent}>{working_hours_h}</Typography> : <Typography noWrap className={classes.typographyContent}>{working_hours_h}</Typography>),
                    <Typography noWrap className={classes.typographyContent}>{type_name}</Typography>,
                    <Typography noWrap className={classes.typographyContent}>{site_name}</Typography>,
                    <Typography noWrap className={classes.typographyContent}>{location}</Typography>,
                    <Typography noWrap className={classes.typographyContent}>{ref}</Typography>,
                    this.operationViewFinish(captured_image),
                    this.operationViewEdit(id, name, Math.floor(history[i]['working_hours']), Math.floor(history[i]['pay_hours']), worker_id, site_id, site_name, type_id, type_name),
                    <Typography noWrap className={classes.typographyContent}>{highlight_row}</Typography>,
                ]
                ];
                temp_history = [
                    ...temp_history,
                    { Week: week, Name: name, No: no, Start: start_time, Finish: finish_time, Date: date, 'Working Hours(m)': working_hours, 'Working Hours(h)': working_hours_h, Type: type_name, Site: site_name, Location: location, Ref: ref, Image: image_url }
                ];
            }

            const { pageNumber } = this.state;
            let temp_page = [];
            temp_page = temp;

            this.setState({ pageNumber: pageNumber, isLoading: false, history_count: history.length, history: temp, temp_page: temp_page, export_history: temp_history })


        }
        catch (error) {
            let messageProperty = Object.getOwnPropertyDescriptor(error, 'message');
            this.setState({ isLoading: false });
            this.props.enqueueSnackbar(messageProperty.value, {
                variant: 'error',
            });
        }
    }
    operationViewFinish = (captured_image) => {
        return (
            <Grid container>
                {this.viewButtonFinish(captured_image)}
            </Grid>
        )
    }
    viewButtonFinish = (captured_image) => {
        const { classes } = this.props;
        return (
            <Button color="secondary" className={classes.viewButton} disableRipple disableFocusRipple onClick={(id) => this.onActionViewImage(captured_image)} >
                {'View'}
            </Button>
        );
    }
    onActionViewImage = (captured_image) => {
        this.setState({ open_image: true, base64: captured_image });
    }
    operationViewEdit = (id, name, working_hour, pay_hour, worker_id, site_id, site_name, type_id, type_name) => {
        return (
            <Grid container>
                {this.viewButtonEdit(id, name, working_hour, pay_hour, worker_id, site_id, site_name, type_id, type_name)}
            </Grid>
        )
    }

    viewButtonEdit = (id, name, working_hour, pay_hour, worker_id, site_id, site_name, type_id, type_name) => {
        const { classes } = this.props;
        return (
            <Button color="secondary" className={classes.viewButton} disableRipple disableFocusRipple onClick={() => this.onActionViewEdit(id, name, working_hour, pay_hour, worker_id, site_id, site_name, type_id, type_name)} >
                {'Edit'}
            </Button>
        );
    }
    onActionViewEdit = (id, name, working_hour, pay_hour, worker_id, site_id, site_name, type_id, type_name) => {
        this.setState({ open_edit: true, id: id, name: name, working_hour: working_hour, pay_hour: pay_hour, worker_id: worker_id, site_id: site_id, site_name: site_name, type_id: type_id, type_name: type_name });
    }
    onCloseRegister = () => {
        this.setState({ open_image: false, open_edit: false });
    }
    onDoneEdit = () => {
        this.setState({ open_edit: false });
        const { pageNumber, search_str } = this.state;
        this.getHistory(pageNumber, search_str);
    }
    onAlertMessage = (type, message) => {
        this.props.enqueueSnackbar(message, {
            variant: type,
        });
    }

    handleChange = search_str => event => {
        this.setState({
            [search_str]: event.target.value,
        });

        const self = this;

        if (self.state.typingTimeout) {
            clearTimeout(self.state.typingTimeout);
        }

        self.setState({
            [search_str]: event.target.value,
            typing: false,
            typingTimeout: setTimeout(function () {
                // self.sendToParent(self.state.name);
                self.getHistory(self.state.pageNumber, self.state.search_str);
            }, 2000)
        });


    };
    // action for pagination
    handleChangePage = (event, page) => {
        const { pageNumber, history } = this.state;
        this.setState({
            pageNumber: page + 1,
        });
    }

    render() {
        const { classes } = this.props;
        const { totalCount, pageNumber, temp_page, history_count, isLoading, export_history, sites, types, name, search_str } = this.state;
        return (
            <GridContainer>

                <div className={classes.topHeaderContainer}>
                    <div className={classes.leftContainer}>
                    </div>
                    <div className={classes.rightContainer}>

                        <OutlinedInput
                            id="ibName"
                            placeholder="Week/Name/No"
                            classes={{
                                root: classes.inputbaseRoot,
                                input: classes.inputbaseInput,
                            }}
                            value={search_str}
                            onChange={this.handleChange('search_str')}
                            fullWidth
                        />
                    </div>

                </div>

                <GridItem xs={12} sm={12} md={12}>
                    <Card>

                        <CardHeader color="secondary">
                            <h4 className={classes.cardTitleWhite}>Working History</h4>
                            {/* <img style={{width:50, height:50}} src={ic_pdf} /> */}
                            {/* <p className={classes.cardCategoryWhite}>
                            Here is a subtitle for this table
                            </p> */}
                        </CardHeader>
                        <CardBody>
                            <Table
                                tableHeaderColor="black"
                                tableHead={[<b>Week</b>, <b>Name</b>, <b>No</b>, <b>Start</b>, <b>Finish</b>, <b>Date</b>, <b>Working Hours(m)</b>, <b>Working Hours(h)</b>, <b>Type</b>, <b>Site</b>, <b>Location Info</b>, <b>Ref</b>, <b>Image</b>, <b>Action</b>]}
                                tableData={temp_page}
                                handleChangePage={this.handleChangePage}
                                totalCount={temp_page.length}
                                containerHeight={620}
                                rowsPerPage={10}
                                page={pageNumber}
                                isLoading={isLoading}
                                tableOrder="desc"
                                tableOrderBy={5}
                            />
                            <Grid container xs={12} sm={12} md={12}>
                                <Grid container direction="column" justify="center" alignItems="stretch" xs={12} sm={12} md={8}>
                                </Grid>
                                <Grid container direction="column" justify="center" alignItems="stretch" xs={12} sm={12} md={3}>
                                        <Button variant="contained" color="primary" className={classes.btnUpdate} disableRipple onClick={this.exportLastWeek}>
                                            Export Last Week
                                    </Button>
                                    <ExcelExport fileName="lastweek_history.xlsx" ref={(exporter) => { this._exporterLastWeek = exporter; }}>
                                    </ExcelExport>
                                </Grid>

                                <Grid container direction="column" justify="center" alignItems="stretch" xs={12} sm={12} md={1}>
                                    <Workbook filename="history.xlsx" element={<Button variant="contained" color="primary" className={classes.btnUpdate} disableRipple>Export</Button>}>
                                        <Workbook.Sheet data={export_history} name="Sheet A">
                                            <Workbook.Column label="Ref" value="Ref" />
                                            <Workbook.Column label="Date" value="Date" />
                                            <Workbook.Column label="Week" value="Week" />
                                            <Workbook.Column label="Name" value="Name" />
                                            <Workbook.Column label="No" value="No" />
                                            <Workbook.Column label="Type" value="Type" />
                                            <Workbook.Column label="Site" value="Site" />
                                            <Workbook.Column label="Start" value="Start" />
                                            <Workbook.Column label="Finish" value="Finish" />
                                            <Workbook.Column label="Working Hours" value="Working Hours(m)" />
                                            <Workbook.Column label="Working Hours h" value="Working Hours(h)" />
                                            <Workbook.Column label="Location" value="Location" />
                                            <Workbook.Column label="Image" value="Image" />
                                        </Workbook.Sheet>
                                    </Workbook>
                                </Grid>
                            </Grid>

                        </CardBody>
                    </Card>
                </GridItem>
                <ImageView
                    onClose={this.onCloseRegister}
                    open={this.state.open_image}
                    base64={this.state.base64} />
                {this.state.open_edit && <Edit
                    onClose={this.onCloseRegister}
                    open={this.state.open_edit}
                    id={this.state.id}
                    name={this.state.name}
                    working_hour={this.state.working_hour}
                    pay_hour={this.state.pay_hour}
                    worker_id={this.state.worker_id}
                    site_id={this.state.site_id}
                    site_name={this.state.site_name}
                    type_id={this.state.type_id}
                    type_name={this.state.type_name}
                    sites={this.state.sites}
                    types={this.state.types}
                    onDoneEdit={this.onDoneEdit}
                    onAlertMessage={this.onAlertMessage} />}

            </GridContainer >
        );
    }
}

WorkingHistory.propTypes = {
    classes: PropTypes.object.isRequired
};


export default withStyles(styles)(withSnackbar(WorkingHistory));
